/* @flow */
import React from 'react';
import Avatar from 'components/Avatar.jsx';
import Link from 'components/Link.jsx';

import './styles/ChatListNewActivityItem.scss';

type Props = {
  onClick?: () => void,
  canCollectMoney: boolean,
};

function ChatListNewActivityItem(props: Props) {
  return (
    <div onClick={props.onClick} className="ChatListActivities-item ChatListNewActivityItem">
      <div className="ChatListActivities-item-droplet">
        <Avatar color="brand" glyphName="calendar-stroke" size="medium" />
      </div>
      <div className="ChatListActivities-item-body">
        <div>
          <Link
            className="ChatListNewActivityItem-header"
            eventElementName="ChatListNewActivityItem-header">
            Create an activity
          </Link>
        </div>
        <div className="ChatListActivities-item-body-subtext">
          <span>
            {props.canCollectMoney ?
              'Manage invitations and collect funds' :
              'Send invitations and track RSVPs'
            }
          </span>
        </div>
        <hr style={{ border: 'none' }} className="ChatListActivities-item-divider" />
      </div>
    </div>
  );
}

export default ChatListNewActivityItem;



// WEBPACK FOOTER //
// ./src/chat/components/ChatListNewActivityItem.jsx